import type { ReactNode } from 'react';

import { cn } from '../lib/cn';

// 12px and `muted`, not 10px `faint`: at the smaller size ↵ ⌘D ⌫ were a smudge to guess at.
export const Kbd = ({ children, className }: { children: ReactNode; className?: string }) => (
  <kbd
    className={cn(
      'inline-flex min-w-keycap items-center justify-center rounded-tag border border-border-raised px-label py-tight font-mono text-meta font-medium text-muted',
      className,
    )}
  >
    {children}
  </kbd>
);
